import { useContext } from 'react';

import ComposerContext from 'components/composer/contexts/composer_context';

export default function useHasRemovableThread() {
  const { composition } = useContext(ComposerContext);
  return !!composition.content.quotedPlain;
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/email/use_has_removable_thread.js